import axios from 'axios'
import { useCallback, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'src/hook'
import { UserServices } from 'src/services/user'
import { setUserInfo } from 'src/store/user'
import useLogout from './useLogout'

const useGetUserInfo = () => {
  const { logoutHandler } = useLogout()

  axios.interceptors.response.use(
    response => response,
    (error: any) => {
      const { status } = error.response
      if (status === 401) logoutHandler()

      return Promise.reject(error)
    },
  )

  const { getUserInfo } = UserServices()
  const dispatch = useAppDispatch()
  const token = useAppSelector(state => state.user.token)

  const getUserInfoReq = useCallback(async () => {
    const res = await getUserInfo()
    res.data && dispatch(setUserInfo(res.data))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (token) getUserInfoReq()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])
}

export default useGetUserInfo
